module.exports = __webpack_public_path__ + "static/kitchen-ac725cab354404f65ffed1f3ee032dca.jpg";